<template>
    <v-select
        style="height:39px; overflow:visible!important;"
        :options="foundTags"
        class="large"
        @search-change="searchTags"
        @select="addTags"
        v-model="selectedTag"
        :placeholder="getSearchTagVal()"
        ref="searchTags"
    ></v-select>
</template>

<script>
    export default {
        data: () => ({
            foundTags: [],
            excludeTagIds: [],
            selectedTag: null,
        }),
        methods: {
            addTags(payload) {
                this.$emit('selected', payload.value)
            },
            searchTags(query) {
                if (query.length > 2) {
                    this.axios.post('/getServices', {
                        q:query,
                        except: this.excludeTagIds
                    }).then(response => {
                        this.foundTags = response.data.map(item => {
                            return {
                                value: item.id,
                                text: item.name,
                            }
                        })
                    })
                }
            },
            getSearchTagVal() {
                const searchVal = this.$refs.searchTags && this.$refs.searchTags.$refs.multiselect
                    ? this.$refs.searchTags.$refs.multiselect.search
                    : '';

                return searchVal ? searchVal : 'искать';
            }
        },
    }
</script>
